import { ReactNode, createContext, useState } from 'react';
import { WarningsState } from '../@types/warnings_state';

type WarningsContextProps = {
  warningsState: WarningsState;
  changeWarningsState: (type: string, state: boolean) => void;
};

const warningsDefaultState = {
  deleteForbiddenLo: false,
  deleteLo: false,
  deleteList: false,
  syncLo: false,
  syncList: false,
  favoriteList: false,
  unfavoriteList: false,
  masquerade: false,
};

const initialState: WarningsContextProps = {
  warningsState: warningsDefaultState,
  changeWarningsState: () => {},
};

const WarningsContext = createContext(initialState);

type WarningsProviderProps = {
  children: ReactNode;
};

function WarningsProvider({ children }: WarningsProviderProps) {
  const [warnings, setWarnings] = useState(warningsDefaultState);

  const changeWarningsState = (type: string, state: boolean) => {
    setWarnings((prevState) => ({ ...prevState, [type]: state }));
  };

  return (
    <WarningsContext.Provider value={{ warningsState: warnings, changeWarningsState }}>
      {children}
    </WarningsContext.Provider>
  );
}

export { WarningsProvider, WarningsContext };
